import React, { useState } from 'react';
import { Tab, Row, Col, Nav, ButtonGroup, Button } from 'react-bootstrap';

export default function Swap() {
  
  const [dynamicRate, setDynamicRate] = useState(true)

  return (
    <>
      <div className="swap mtb15">
        <div className="container-fluid">
          <Tab.Container defaultActiveKey="choose">
            <Row>
              <Col lg={2} className="mb-3">
                <Nav variant="pills" className="swap-nav">
                  <Nav.Item>
                    <Nav.Link eventKey="choose">Choose</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="send">Send</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="receive">Receive</Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col lg={10}>
                <Tab.Content>
                  <Tab.Pane eventKey="choose">
                    <div className="card">
                      <div className="card-body">
                        <div className="swap-choose">
                          <ButtonGroup className="mb-3 p-2 btn-rate-group">
                            <Button className={dynamicRate ? "btn-rate active" : "btn-rate"} onClick={() => {setDynamicRate(!dynamicRate)}} variant="">Dynamic Rate</Button>
                            <Button className={!dynamicRate ? "btn-rate active" : "btn-rate"} onClick={() => {setDynamicRate(!dynamicRate)}} variant="">Fixed Rate</Button>
                          </ButtonGroup>
                          <Row>
                            <Col md={2} className="text-center">
                              <img src="img/BTC.png" width="64px" height="64px" className="img-circle cryptoexchanger-icon2" alt="BTC" />
                            </Col>
                            <Col md={7}>
                              <div className="form-group">
                                <label>You send</label>
                                <select className="custom-select">
                                  <option key="1" value="BTC">Bitcoin BTC</option>
                                  <option key="2" value="ETH">Ethereum ETH</option>
                                </select>
                              </div>
                            </Col>
                            <Col md={3}>
                              <div className="form-group">
                                <label>Amount</label>
                                <input type="number" className="form-control" required="" id="etheramount" step="0.00001"
                                  pattern="^\d*(\.\d{0,8})?$" value={0.01} />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={10} xs={10} className="pl-5">
                              <span>
                                <i className="fa fa-lock mr-3"></i>
                                <span>1 BTC ~ 15.89149846 BTC</span>
                              </span>
                            </Col>
                            <Col lg={2} xs={2}>
                              <button type="button" className="btn btn-light switch-button pull-right">
                                <i className="fa fa-refresh"></i>
                              </button>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={2} xs={2} className="text-center">
                              <img src="img/ETH.png" width="64px" height="64px" className="img-circle cryptoexchanger-icon2" alt="ETH" />
                            </Col>
                            <Col md={7} xs={7}>
                              <div className="form-group">
                                <label>You get approximately</label>
                                <select className="custom-select">
                                  <option key="1" value="btc">BTC</option>
                                </select>
                              </div>
                            </Col>
                            <div className="col-md-3 col-xs-3">
                              <div className="form-group">
                                <label>Amount</label>
                                <input type="number" className="form-control" required="" id="bitcoinamount" value={0.15891} disabled />
                              </div>
                            </div>
                          </Row>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>Please enter your 12 wallet address</label>
                                <input type="text" className="form-control" id="mybtcaddressinput" v-model="recipient" />
                                {/* <small style={{ color: 'palevioletred' }}>Please enter a valid address</small> */}
                              </div>
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-12">
                              <button className="btn btn-info btn-block w-50 mx-auto">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="send">
                    <div className="card">
                      <div className="card-body">
                        <div className="swap-send">
                          <h5 className="mb-3">TradeID: sEKCaDBqYZsGUFB</h5>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="">
                                <div className="row">
                                  <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div>
                                      <i>If the exact amount is not sent, it will not be automatiaclly detected and we have to manually process it</i>
                                      <h4 className="mt-4">Send this amount</h4>
                                    </div>
                                    <div>
                                      <h4 className="my-4">0</h4>
                                    </div>
                                    <div>
                                      <h4>To this address</h4>
                                    </div>
                                    <div>
                                      <h4 className="my-3">&nbsp;</h4>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div id="qrcode">
                                    </div>
                                    <div>
                                      <h4 className="mt-4">Time left:</h4>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div>
                                <h4>You Receive</h4>
                              </div>
                            </div>
                          </div>

                          <div>
                            <h4 className="mt-4">&#8776; 0</h4>
                          </div>

                          <div className="mb-3">
                            <i>The rate locks after "confirm" stage. In most cases, only 1 confirmation is required</i>
                          </div>

                          <div className="pl-3">
                            <h4>Network Fee:</h4>
                            <div>
                              <h4 className="my-3">0</h4>
                            </div>
                            <div>
                              <i>This fee is deducted from the final amount you receive</i>
                            </div>
                          </div>
                          
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <h4 className="my-3">Recipient Wallet</h4>
                              <h4>&nbsp;</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-body">
                        <ul class="swap_progressbar_botton">
                          <li className="active">Deposit</li>
                          <li>Confirm</li>
                          <li>Swap</li>
                          <li>Receive</li>
                        </ul>
                      </div>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="receive">
                    <div className="card">
                      <div className="card-body">
                        <div className="swap-receive">
                    
                          <h5 className="mb-3">TradeID: cAZrvfoP81tGPPL</h5>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                                <div>
                                    <h5 className="mb-3">You sent:</h5>
                                </div>
                                <div>
                                    <h5>0</h5>
                                </div>
                                <div>
                                    <h5 className="my-3">You received:</h5>
                                </div>
                                <div>
                                    <h5>0</h5>
                                </div>
                                <div>
                                    <h5 className="my-3">To the following address:</h5>
                                </div>
                                <div>
                                    <h5>&nbsp;</h5>
                                </div>
                                <div>
                                    <h5 className="my-3">Final Exchange rate :</h5>
                                </div>
                                <div>
                                    <h5>0=1</h5>
                                </div>
                                                            
                                <div className="mt-4" style={{ color: '#afaeae' }}>
                                    <h6>This exchange took 20 minutes</h6>
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                          <img src="img/congrats.gif" alt="Congratulations" />
                        </div>
                      </div>
                      </div>
                      </div>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </div>
    </>
  );
}
